import React from 'react';
import { Flex, Box } from '@chakra-ui/react';
import DataPlusTopbar from './components/DataPlusTopbar';
import Sidebar from '#coreComponents/Sidebar';
import BrowserSupport from '#coreComponents/BrowserSupport';
import { PrivateRouteLayoutProps } from '#coreComponents/PrivateRoute/PrivateRoute';

const DataPlusLayout: React.FC<PrivateRouteLayoutProps> = ({
  children,
  pageConfig,
}) => (
  <Flex position="relative">
    <Box
      position="fixed"
      left={0}
      height={{ base: 'initial', xl: '100vh' }}
      zIndex="docked"
    >
      <Sidebar />
    </Box>
    <Box
      w="100%"
      ml={{ lg: 250 }}
      maxWidth={{ lg: 'calc(100% - 250px)' }}
      mt={{ base: 128, lg: 68 }}
      px={{ base: 2, lg: 6 }}
      py={{ base: 4, lg: 6 }}
    >
      <BrowserSupport />
      <DataPlusTopbar {...pageConfig.topbar} />
      {children}
    </Box>
  </Flex>
);

export default DataPlusLayout;
